export default theme => ({
  counter: {
    color: theme.palette.primary.main
  }
});
